import { Box, Button, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import { flexMixin } from 'utils/flexMixin';

import { ReactComponent as Refresh } from 'assets/icons/refresh.svg';
import { regularTextColor } from 'assets/styles/_palette';

import * as Styled from './styled';

interface EditUserStoriesDropdownProps {
	header: ReactNode;
	storyIndex: number;
	isDeleted: boolean;
	handleDelete: () => void;
	handleRefresh: () => void;
}

export const EditUserStoriesDropdown: FC<EditUserStoriesDropdownProps> = ({
	header,
	storyIndex,
	isDeleted,
	handleDelete,
	handleRefresh,
}) => {
	return (
		<>
			<Styled.EditUserStoriesHeader>
				<Box
					sx={{
						...flexMixin({
							justify: 'flex-start',
							gap: 5,
						}),
					}}
				>
					<Typography sx={{ color: regularTextColor }}>{storyIndex + 1}.</Typography>
					{header}
					<Box
						sx={{
							...flexMixin({ direction: 'column', gap: 15 }),
							height: '100%',
						}}
					>
						{!isDeleted ? (
							<Button
								type="button"
								sx={{
									minWidth: '24px',
									height: '24px',
									fontSize: '24px',
									color: '#9FA6B3',
								}}
								onClick={handleDelete}
							>
								<span>&times;</span>
							</Button>
						) : (
							<Button
								type="button"
								sx={{
									minWidth: '24px',
									height: '24px',
									fontSize: '24px',
									color: '#9FA6B3',
								}}
								onClick={handleRefresh}
							>
								<Refresh />
							</Button>
						)}
					</Box>
				</Box>
			</Styled.EditUserStoriesHeader>
		</>
	);
};
